/*
  GILLSEE CUP トップページ（sections/c__gillsee-cup-top.liquid 用）
  栗林さん提供の TOP/script.js をそのまま使っている（処理の変更なし）。
*/
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.gc-top .gc-reveal').forEach(el =>
    new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) e.target.classList.add('is-visible');
    }), { threshold: .15 }).observe(el)
  );
});

document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.gc-top');
  if (!root) return;

  const reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  const targets = [...root.querySelectorAll(
    '.gc-section .gc-wrap,.gc-photo,.gc-copy,.gc-events>* ,.gc-how>div'
  )];

  targets.forEach((el, i) => {
    el.classList.add('gc-motion');
    if (el.classList.contains('gc-photo')) el.dataset.motion = i % 2 ? 'right' : 'left';
    if (el.classList.contains('gc-copy')) el.dataset.motion = i % 2 ? 'left' : 'right';
    el.style.transitionDelay = ((i % 3) * .09) + 's';
  });

  if (!reduce) {
    const io = new IntersectionObserver(es => es.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    }), { threshold: .12 });
    targets.forEach(x => io.observe(x));
  } else {
    targets.forEach(x => x.classList.add('is-in'));
  }

  const bar = document.createElement('div');
  bar.className = 'gc-scroll-progress';
  document.body.appendChild(bar);
  const hero = root.querySelector('.gc-hero');
  let busy = false;

  const paint = () => {
    const max = document.documentElement.scrollHeight - innerHeight;
    bar.style.width = (max ? scrollY / max * 100 : 0) + '%';
    if (hero && !reduce && scrollY < innerHeight * 1.2) {
      hero.style.setProperty('--gc-parallax', (scrollY * .16) + 'px');
    }
    busy = false;
  };

  addEventListener('scroll', () => {
    if (!busy) {
      requestAnimationFrame(paint);
      busy = true;
    }
  }, { passive: true });
  paint();
});
